import { create } from 'zustand';

/** One app-wide search palette: the header button, ⌘K / Ctrl+K and "/" all open the same one. */
interface GlobalSearchState {
  open: boolean;
  /** Text to start with (e.g. a prefix like "order: "). */
  initial: string;
  show: (initial?: string) => void;
  hide: () => void;
  toggle: () => void;
  /** A question handed to the workspace assistant ("Ask the assistant about …"); it fills the assistant's box. */
  assistantSeed: string;
  setAssistantSeed: (text: string) => void;
}

export const useGlobalSearchStore = create<GlobalSearchState>((set, get) => ({
  open: false,
  initial: '',
  show: (initial = '') => set({ open: true, initial }),
  hide: () => set({ open: false, initial: '' }),
  toggle: () => (get().open ? set({ open: false, initial: '' }) : set({ open: true, initial: '' })),
  assistantSeed: '',
  setAssistantSeed: (assistantSeed) => set({ assistantSeed }),
}));
